import { render, staticRenderFns } from "./ReporteGarantias.vue?vue&type=template&id=4ff644ae"
import script from "./ReporteGarantias.vue?vue&type=script&lang=js"
export * from "./ReporteGarantias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports